import { z } from 'zod';
import { paginationFiltersSchema, sortFiltersSchema } from 'utils/schemas';
import { clientAdminStatuses } from './admin-client-admins.types';

export const clientAdminsFiltersSchema = z
  .object({
    admins: z.array(z.string()).catch([]),
    status: z.array(z.enum(clientAdminStatuses)).catch([]),
    search: z.string().catch(''),
  })
  .merge(sortFiltersSchema)
  .merge(paginationFiltersSchema);
